import xss from 'xss';

const xssOptions: XSS.IFilterXSSOptions = {
  whiteList: {
    a: ['class', 'href', 'title', 'target', 'media', 'referrerpolicy', 'rel', 'type'],
    b: ['class'],
    i: ['class'],
    u: ['class'],
    s: ['class'],
    p: ['class', 'data-placeholder', 'max-w-fit', 'max-w-[100%]', 'max-w-full', 'w-fit', 'w-full'],
    br: ['*', 'class', 'data-*'],
    ul: ['class', 'list-none', 'list-disc', 'list-none', 'list-decimal'],
    ol: ['class', 'list-none', 'list-decimal'],
    li: ['class', 'list-none'],
    strong: ['class'],
    em: ['class'],
    blockquote: ['class'],
    code: ['class'],
    pre: ['class'],
    h1: ['class'],
    h2: ['class'],
    h3: ['class'],
    h4: ['class'],
    h5: ['class'],
    h6: ['class'],
    img: ['src', 'alt', 'title', 'width', 'height', 'class', 'max-w-fit', 'max-w-[100%]', 'max-w-full', 'w-fit'],
    span: ['data-id', 'data-label', 'data-type', 'data-url', 'data-platform', 'class'],
    div: ['class'],
    iframe: ['src', 'title', 'width', 'inline', 'controls', 'height', 'origin', 'allowfullscreen', 'autoplay'],
  },
  stripIgnoreTag: true,
  stripIgnoreTagBody: ['script'],
};

export const sanitize = (html: string) => {
  return xss(html, xssOptions);
};